import { body as bodyAsObj, headline as headlineAsObj, textSans as textSansAsObj, titlepiece as titlepieceAsObj, } from './api';
import { bodySizes, fontMapping, fontWeightMapping, headlineSizes, lineHeightMapping, remBodySizes, remHeadlineSizes, remTextSansSizes, remTitlepieceSizes, textSansSizes, titlepieceSizes, } from './data';
import { objectStylesToString } from './object-styles-to-string';
const titlepiece = Object.fromEntries(Object.entries(titlepieceAsObj).map(([key, func]) => {
    return [
        key,
        (options) => objectStylesToString(func(options)),
    ];
}));
const headline = Object.fromEntries(Object.entries(headlineAsObj).map(([key, func]) => {
    return [
        key,
        (options) => objectStylesToString(func(options)),
    ];
}));
const body = Object.fromEntries(Object.entries(bodyAsObj).map(([key, func]) => {
    return [
        key,
        (options) => objectStylesToString(func(options)),
    ];
}));
const textSans = Object.fromEntries(Object.entries(textSansAsObj).map(([key, func]) => {
    return [
        key,
        (options) => objectStylesToString(func(options)),
    ];
}));
export { titlepiece, headline, body, textSans, titlepieceSizes, headlineSizes, bodySizes, textSansSizes, remTitlepieceSizes, remHeadlineSizes, remBodySizes, remTextSansSizes, fontMapping as fonts, fontWeightMapping as fontWeights, lineHeightMapping as lineHeights, };
//# sourceMappingURL=index.js.map
